import { __spreadArray } from "tslib";
import { useState } from 'react';
var useCheckboxes = function (initial) {
    if (initial === void 0) { initial = []; }
    var _a = useState(initial), selected = _a[0], setSelected = _a[1];
    var handleCheckBoxes = function (props) {
        var checkboxName = props.name;
        var isChecked = props.checked;
        if (!checkboxName)
            return;
        if (selected.includes(checkboxName)) {
            if (!isChecked) {
                return setSelected(function (prevState) { return __spreadArray([], prevState.filter(function (e) { return e !== checkboxName; }), true); });
            }
        }
        return setSelected(function (prevState) {
            return __spreadArray(__spreadArray([], prevState, true), (!prevState.includes(checkboxName) ? [checkboxName] : []), true);
        });
    };
    return {
        handleCheckBoxes: handleCheckBoxes,
        selected: selected
    };
};
export default useCheckboxes;
//# sourceMappingURL=useCheckboxes.js.map